const NavItems = [
    {
        id: "item1",
        name: 'محدوده ها',
        link: "/dashboard/areas",
        iconClassName: "fa fa-map-marker",
    },
    {
        id: "item16",
        name: "سفارشات کالا",
        link: "/dashboard/product-orders",
        iconClassName: "fa fa-list-alt",
    },
    {
        id: "item13",
        name: "دسته بندی کالا ها",
        link: "/dashboard/productcategories",
        iconClassName: "fa fa-list-alt",
    },
    {
        id: "item14",
        name: "کالا ها",
        link: "/dashboard/products",
        iconClassName: "fa fa-list-alt",
    },
    {
        id: "item15",
        name: "ایجاد کالای جدید",
        link: "/dashboard/newproduct",
        iconClassName: "fa fa-list-alt",
    },
    {
        id: "item2",
        name: "دسته بندی شغل ها",
        link: "/dashboard/jobcategories",
        iconClassName: "fa fa-list-alt",
    },
    {
        id: "item4",
        name: "متخصصین",
        link: "/dashboard/persons",
        iconClassName: "fa fa-list",
    },
    {
        id: "item3",
        name: "ایجاد متخصص جدید",
        link: "/dashboard/newperson",
        iconClassName: "fa fa-plus",
    },
    {
        id: "item5",
        name: "دسته بندی مکان ها",
        link: "/dashboard/placecategories",
        iconClassName: "fa fa-list-alt",
    },
    {
        id: "item6",
        name: "مکان ها",
        link: "/dashboard/places",
        iconClassName: "fa fa-list",
    },
    {
        id: "item7",
        name: "ایجاد مکان جدید",
        link: "/dashboard/newplace",
        iconClassName: "fa fa-plus",
    },
    {
        id: "item8",
        name: "سفارشات خدمات",
        link: "/dashboard/orders",
        iconClassName: "fa fa-cart-arrow-down",
    },
    {
        id: "item9",
        name: "ایجاد سفارش جدید",
        link: "/dashboard/neworder",
        iconClassName: "fa fa-pencil-square-o",
    },
    {
        id: "item10",
        name: "کاربران",
        link: "/dashboard/users",
        iconClassName: "fa fa-users",
    },
    {
        id: "item11",
        name: "نظرات",
        link: "/dashboard/comments",
        iconClassName: "fa fa-comments",
    },
    {
        id: "item12",
        name: "بازدیدهای سایت",
        link: "/dashboard/viewers",
        iconClassName: "fa fa-television",
    }
];


const getNavItems = () => {
    return [...NavItems];
};

export default getNavItems;
